import {computed, signal} from "@preact/signals-react";
import {
	differenceBetweenDates, FORMAT_DATE_BACK, formatDate, getCurrentDate, getPreviousDate,
	getMonth, getQuarter, getYear
} from "@ui-seeker/utils";

import {DATE_PERIODS, PREVIOUS_PERIODS} from "@constants";


const currentDay = new Date().getDay()
const currentMonth = getMonth()
const currentYear = getYear()
const currentQuarter = getQuarter()

const lastQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1
const lastQuarterMonth = lastQuarter * 3
const lastQuarterYear = currentQuarter === 1 ? currentYear - 1 : currentYear

//Signals
export const currentPeriod = signal(DATE_PERIODS.YESTERDAY)
export const dateRange = signal([ getPreviousDate({ days: 1 }), getPreviousDate({ days: 1 }) ])
export const currentSingleDate = signal(getPreviousDate({ days: 1 }))
export const prevSingleDate = signal(getPreviousDate({ days: 1 }, currentSingleDate.value))

// Computed
export const dateRangePeriod = computed(() => ({
    [DATE_PERIODS.TODAY]: [getCurrentDate(), getCurrentDate()],
    [DATE_PERIODS.YESTERDAY]: [getPreviousDate({ days: 1 }), getPreviousDate({ days: 1 })],
    [DATE_PERIODS.LAST_7_DAYS]: [getPreviousDate({ days: 7 }), getPreviousDate({ days: 1 })],
    [DATE_PERIODS.LAST_14_DAYS]: [getPreviousDate({ days: 14 }), getPreviousDate({ days: 1 })],
    [DATE_PERIODS.LAST_30_DAYS]: [getPreviousDate({ days: 30 }), getPreviousDate({ days: 1 })],
	[DATE_PERIODS.LAST_60_DAYS]: [getPreviousDate({ days: 60 }), getPreviousDate({ days: 1 })],
	[DATE_PERIODS.LAST_90_DAYS]: [getPreviousDate({ days: 90 }), getPreviousDate({ days: 1 })],
    [DATE_PERIODS.LAST_MONTH]: [
        getPreviousDate({ months: 1 }, new Date(currentYear, currentMonth - 1, 1)),
        getPreviousDate({ days: 1 },  new Date(currentYear, currentMonth - 1, 1))
    ],
	[DATE_PERIODS.LAST_QUARTER]: [
        new Date(lastQuarterYear, lastQuarterMonth - 3, 1),
        new Date(lastQuarterYear, lastQuarterMonth, 0)
    ],
    [DATE_PERIODS.YEAR_TO_DATE]: [
        new Date(currentYear, 0, 1),
        currentDay === 1 && currentMonth === 0 ? new Date(currentYear, 0, 1) : getPreviousDate({ days: 1 })
    ],
    [DATE_PERIODS.LAST_YEAR]: [
        getPreviousDate({ years: 1 }, new Date(currentYear, 0, 1)),
        getPreviousDate({ years: 1 }, new Date(currentYear, 12, 0))
	],
	[DATE_PERIODS.CURRENT_YEAR]: [
		new Date(currentYear, 0, 1),
		new Date(currentYear, 11, 31)
	],
	[DATE_PERIODS.CUSTOM]: dateRange.value,
}[currentPeriod.value]))
export const startDate = computed(() => formatDate(dateRange.value[0], { format: FORMAT_DATE_BACK }))
export const endDate = computed(() => formatDate(dateRange.value[1], { format: FORMAT_DATE_BACK }))
export const currentSingleDateStr = computed(() => formatDate(currentSingleDate.value, { format: FORMAT_DATE_BACK }))
export const prevSingleDateStr = computed(() => formatDate(getPreviousDate({ days: 1 }, currentSingleDate.value), { format: FORMAT_DATE_BACK }))
export const prevStartDate = computed(() => {
	const __prevRange = currentPeriod.value === DATE_PERIODS.CUSTOM
		? __calculateCustomPrevious(dateRange.value)
		: (PREVIOUS_PERIODS[currentPeriod.value] || __calculateCustomPrevious(dateRangePeriod.value))
	return formatDate(__prevRange[0], { format: FORMAT_DATE_BACK })
})
export const prevEndDate = computed(() => {
	const __prevRange = currentPeriod.value === DATE_PERIODS.CUSTOM
		? __calculateCustomPrevious(dateRange.value)
		: (PREVIOUS_PERIODS[currentPeriod.value] || __calculateCustomPrevious(dateRangePeriod.value))
	return formatDate(__prevRange[1], { format: FORMAT_DATE_BACK })
})

// Utils
const __calculateCustomPrevious = ([startDate, endDate]) => {
	const diff = differenceBetweenDates(startDate, endDate, { isString: false }) * -1
	return [
		getPreviousDate({ days: diff + 1 }, startDate),
		getPreviousDate({ days: diff + 1 }, endDate)
	]
}